<template>
    <div>
        <h3>Add User</h3>
        <hr>
        <br>
        <div class="container">
            <div class="col-sm-3 col-xs-2"></div>
            <div class="col-sm-6 col-xs-8">
                <div class="row">
                    <div class="col-sm-3 col-xs-0"></div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="form-group has-feedback has-feedback-left">
                            <input type="text" class="form-control" v-model="username" name="username" maxlength="30" placeholder="Username"  />
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-0"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-3 col-xs-0"></div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="form-group has-feedback has-feedback-left">
                            <input type="text" class="form-control" v-model="password" name="password" maxlength="16" placeholder="Password"  />
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-0"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-3 col-xs-0"></div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="form-group has-feedback has-feedback-left">
                            <input type="text" class="form-control" v-model="name" name="name" maxlength="150" placeholder="Account Name"  />
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-0"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-3 col-xs-0"></div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="form-group has-feedback has-feedback-left">
                            <input type="text" class="form-control" v-model="email" name="email" maxlength="120" placeholder="Email Address"  />
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-0"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-3 col-xs-0"></div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="form-group has-feedback">
                            <select class="form-control" name="UserType" v-model="userType">
                                <option :value="undefined" disabled selected hidden>User Type</option>
                                <option value="User">User</option>
                                <option value="Admin">Admin</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-0"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-sm-3 col-xs-0"></div>
                    <div class="col-sm-6 col-xs-12">
                        <div class="form-group has-feedback">
                            <select class="form-control" name="UserStatus" v-model="userStatus">
                                <option :value="undefined" disabled selected hidden>User Status</option>
                                <option selected="selected" value="Activated">Activated</option>
                                <option value="Deactivated">Deactivated</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-0"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-xs-12"><button class="btn btn-primary" @click="addAccount">Add Account</button></div>
                </div>
            </div>
            <div class="col-sm-3 col-xs-2"></div>
        </div>
    </div>
</template>

<script>
  import swal from 'sweetalert2'
  import axios from 'axios'

  export default {
    name: '',
    data: {
      email: '',
      username: '',
      password: '',
      name: '',
      userType: '',
      userStatus: ''
    },
    methods: {
      addAccount () {
        let emailRegex = RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')

        if (this.email.trim().length !== 0 && emailRegex.test(this.email.trim()) === false) {
          swal('Please enter a valid Email')
          return
        }
        if (this.password.trim().length !== 0 && this.password.trim().length < 6) {
          swal('Please enter a Password that is at least 6 characters long.')
          return
        }
        if (this.name.trim().length !== 0 && this.name.trim().length < 2) {
          swal('Please enter a name longer than 2 characters ')
          return
        }
        if (this.username.trim().length !== 0 && this.username.trim().length < 2) {
          swal('Please enter a username longer than 2 characters ')
          return
        }
        if (this.userStatus === undefined) {
          swal('Please select a user status.')
          return
        }
        if (this.userType === undefined) {
          swal('Please select a user type.')
          return
        }
        axios.post('./static/api/Ajax.php', {
          Name: this.name.trim(),
          Password: this.password.trim(),
          Email: this.email.trim(),
          UserStatus: this.userStatus.trim(),
          UserType: this.userType.trim(),
          Username: this.username.trim(),
          action: 'Add Account'
        }).then((response) => {
          if (response.data.status === 'success') {
            swal('Your account was successfully added.')
          } else {
            swal(response.data.status)
          }
        }).catch((e) => {
          console.log(e)
        })
      }
    },
    mounted () {
      if (this.$store.getters.getUserStatus !== 'Admin') {
        window.location = './#/search'
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/adminMaintenancePage.vue